import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {Uuid} from '../interface/response/uuid';
import {first} from 'rxjs/operators';
import {CommissionAnnex} from '../interface/commission-annex';

@Injectable({
  providedIn: 'root'
})
export class CommissionAnnexService {
  public readonly annexConfigurationListSubject: ReplaySubject<CountedAndPaginated<CommissionAnnex>>
    = new ReplaySubject<CountedAndPaginated<CommissionAnnex>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public sendForm(formData: any, uuid?: string): Observable<Uuid> {
    if (!uuid) {
      return this.httpClient.post(`/rest/crm/commission-annex`, formData)
        .pipe(first()) as Observable<Uuid>;
    } else {
      return this.httpClient.put(`/rest/crm/commission-annex/${uuid}`, formData)
        .pipe(first()) as Observable<Uuid>;
    }

  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/commission-annex?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first(),
      )
      .subscribe((result: CountedAndPaginated<CommissionAnnex>) => {
        this.annexConfigurationListSubject.next(result);
      });
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-annex/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public deleteConfiguration(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/commission-annex/${uuid}`)
      .pipe(first());
  }

  public configure(uuid: string, formData: any): Observable<any> {
    return this.httpClient.post(`/rest/crm/commission-annex/${uuid}/configure`, formData)
      .pipe(first());
  }

  public clone(uuid: string): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-annex/${uuid}/clone`, {})
      .pipe(first()) as Observable<Uuid>;
  }

  public cloneAnnexes(uuid: string, formData): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-annex/${uuid}/clone-annexes`, formData)
      .pipe(first()) as Observable<Uuid>;
  }

  public get(uuid: string): Observable<CommissionAnnex> {
    return this.httpClient.get(`/rest/crm/commission-annex/${uuid}`)
      .pipe(first()) as Observable<CommissionAnnex>;
  }
  public findAnnex(filters: object): Observable<any> {
    return this.httpClient.get(`/rest/crm/commission-annex?` + this.filterService.parseFilters(filters))
      .pipe(first()) as Observable<any>;
  }

  public deleteClone(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/commission-annex-clone/${uuid}`)
      .pipe(first());
  }
}
